import { render, staticRenderFns } from "./p-head.vue?vue&type=template&id=22122f69&scoped=true&"
import script from "./p-head.vue?vue&type=script&lang=js&"
export * from "./p-head.vue?vue&type=script&lang=js&"
import style0 from "./p-head.vue?vue&type=style&index=0&id=22122f69&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22122f69",
  null
  
)

export default component.exports